import { render } from "./CardOrders.vue?vue&type=template&id=d3915350"
import script from "./CardOrders.vue?vue&type=script&lang=js"
export * from "./CardOrders.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__